/** Structural clone via JSON. Models here are plain data, so this is safe and keeps inputs untouched. */
export const deepClone = <T,>(obj: T): T => JSON.parse(JSON.stringify(obj)) as T;
